// extracted by mini-css-extract-plugin
export default {"placeholderWrapper":"SearchPlaceholder_placeholderWrapper__pEa73"};